// ============================================
// SHIFT REMINDER TOAST COMPONENT
// Affiche les rappels de fin de shift en toast
// ============================================

import { useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import { Clock, AlertTriangle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ShiftReminderHandler = () => {
    const { socket, user } = useAuth();

    // Handler pour les rappels d'employé
    const handleEmployeeReminder = useCallback((data) => {
        const { message, minutes_remaining, urgent } = data;
        
        if (urgent) {
            toast.error(message, {
                icon: <AlertTriangle className="w-5 h-5 text-red-500" />,
                duration: 15000,
                action: {
                    label: "Voir",
                    onClick: () => window.location.href = '/clock'
                }
            });
        } else {
            toast.warning(message, {
                icon: <Clock className="w-5 h-5 text-amber-500" />,
                duration: 10000,
                action: {
                    label: "Pointer",
                    onClick: () => window.location.href = '/clock'
                }
            });
        }
    }, []);

    // Handler pour les rappels manager
    const handleManagerReminder = useCallback((data) => {
        const { message, staff_name, service, minutes_remaining, has_checked_in } = data;
        
        const description = has_checked_in 
            ? `${staff_name} doit pointer sa sortie`
            : `${staff_name} n'a pas encore pointé`;
        
        toast.info(message, {
            description,
            icon: <Clock className="w-5 h-5 text-blue-500" />,
            duration: 8000,
            action: {
                label: "Planning",
                onClick: () => window.location.href = '/planning'
            }
        });
    }, []);

    useEffect(() => {
        if (!socket) return;

        // Écouter les rappels d'employé
        const handleMessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                
                if (data.type === 'SHIFT_REMINDER') {
                    handleEmployeeReminder(data.payload);
                } else if (data.type === 'SHIFT_REMINDER_MANAGER') {
                    handleManagerReminder(data.payload);
                }
            } catch (e) {
                // Ignore parsing errors
            }
        };

        socket.addEventListener('message', handleMessage);

        return () => {
            socket.removeEventListener('message', handleMessage);
        };
    }, [socket, handleEmployeeReminder, handleManagerReminder]);

    // Ce composant ne rend rien visuellement
    return null;
};

export default ShiftReminderHandler;
